import SystemAccessLog from './systemAccessLog'
export default SystemAccessLog
